module.exports = __webpack_public_path__ + "img/logo.c75352ac.svg";